import { Content, GroupField } from '@prismicio/client';
import { OptimizedPrismicImage } from '@/components/index';
import { Simplify } from '../../../../../prismicio-types';
import styles from './Table.module.scss';

interface Props {
  titles: GroupField<
    Simplify<Content.AdvantagesOfHelocSliceDefaultPrimaryTableTitlesItem>
  >;

  data: GroupField<
    Simplify<Content.AdvantagesOfHelocSliceDefaultPrimaryTableRowsItem>
  >;
  isVisible: boolean;
}

const Table = ({ titles, data, isVisible }: Props) => {
  return (
    <article
      className={`${styles.wrapper} ${isVisible ? styles.isVisible : ''}`}
    >
      <div className={styles.head}>
        <div className={styles.title} />
        {titles.map((title) => (
          <div className={styles.title} key={title.title}>
            {title.icon && (
              <OptimizedPrismicImage
                field={title.icon}
                className={styles.icon}
              />
            )}
            <p>{title.title}</p>
          </div>
        ))}
      </div>
      {data.map((row) => (
        <div key={row.title} className={styles.row}>
          <div className={styles.rowItem}>{row.title}</div>
          <div className={styles.rowItem}>{row.heloc}</div>
          <div className={styles.rowItem}>{row.credit_cards}</div>
        </div>
      ))}
    </article>
  );
};

export default Table;
